import type { TodoDueDateDescriptor } from '../../schema/TodoDueDateDescriptor';
import { andFilters } from './combineFilters';
import type { TodoFilterFunction } from '../../schema/TodoFilterFunction';
import { buildIsCompleteFilter } from './buildIsCompleteFilter';
import type { OwaDate } from 'owa-datetime';
import type { Todo } from 'owa-todo-types';
import { isDateInDateRange } from 'owa-datetime-utils';

export function buildTodoDueDateDescriptorFilter(
    todoDueDateDescriptor: TodoDueDateDescriptor
): TodoFilterFunction {
    const filters = [
        buildDueDateRangeFilter(todoDueDateDescriptor.startDate, todoDueDateDescriptor.endDate),
    ];
    if (todoDueDateDescriptor.isComplete !== undefined) {
        filters.push(buildIsCompleteFilter(todoDueDateDescriptor.isComplete));
    }
    return andFilters(filters);
}

function buildDueDateRangeFilter(startDate: OwaDate, endDate: OwaDate) {
    return (todo: Todo) =>
        todo.DueDateTime
            ? isDateInDateRange({ start: startDate, end: endDate }, todo.DueDateTime)
            : false;
}
